import { useTranslate } from "@tolgee/react";
import type {
  MxCallStatus,
  MxCallType,
} from "../../../clients/graphqlTypes.js";

export const useMxCallStatusTitle = ({
  type,
  status,
}: {
  type?: MxCallType | null;
  status?: MxCallStatus | null;
}): string => {
  const { t } = useTranslate("Calls");

  // Check `missed_outgoing` first: such calls can also carry `status: "missed"`,
  // which would otherwise match the generic missed branch below.
  if (type === "missed_outgoing") return t("Missed outgoing call");
  if (status === "missed" || type === "missed") return t("Missed call");
  if (type === "voicemail" || status === "voicemail") return t("Voicemail");
  if (status === "failed") return t("Failed call");
  if (status === "calling") return t("Calling");
  if (status === "in_progress") return t("Call in progress");
  if (status === "completed") {
    if (type === "outgoing") return t("Outgoing call");
    if (type === "incoming") return t("Incoming call");
    if (type === "transfer") return t("Transferred call");
    if (type === "merge") return t("Merged call");
    if (type === "split") return t("Split call");
    return t("Completed call");
  }
  if (type === "outgoing") return t("Outgoing call");
  if (type === "incoming") return t("Incoming call");
  if (type === "transfer") return t("Transferred call");
  if (type === "merge") return t("Merged call");
  if (type === "split") return t("Split call");

  // Both `type` and `status` are nullable. `getMxCallIcon`/`getMxCallAvatarColor`
  // treat a missing type as `incoming`, so mirror that here rather than returning
  // nothing — this string is also the accessible name of the status icon, and an
  // empty one would leave screen-reader users with an unlabeled image.
  return t("Incoming call");
};
